import { render, staticRenderFns } from "./InstallationButton.vue?vue&type=template&id=352c0122&scoped=true&"
import script from "./InstallationButton.vue?vue&type=script&lang=js&"
export * from "./InstallationButton.vue?vue&type=script&lang=js&"
import style0 from "./InstallationButton.vue?vue&type=style&index=0&id=352c0122&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c0122",
  null
  
)

export default component.exports